import { render, staticRenderFns } from "./openDeal.vue?vue&type=template&id=baf89c0e&scoped=true"
import script from "./openDeal.vue?vue&type=script&lang=js"
export * from "./openDeal.vue?vue&type=script&lang=js"
import style0 from "./openDeal.vue?vue&type=style&index=0&id=baf89c0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf89c0e",
  null
  
)

export default component.exports